import React, { Component } from 'react';

class About extends Component {
  render() {
    return (
      <section id="about">
      <div className="row">
         <div className="three columns">
            <img className="profile-pic"  src="images/profilepic.jpg" alt="Alice Gao Profile Pic" />
         </div>
         <div className="nine columns main-col">
            <h2>About Me</h2>
            <p>I am a second year Software Engineering student in the University of Waterloo.</p>
            <p>My likes: [] </p>
         </div>
      </div>
   </section>
    );
  }
}

export default About;
